// export type ALLOWED_SETTINGS_KEYS = "apiUrl";
// export type SettingValue = string | number | boolean | object | null;
export type LanguageOption = "de" | "en";
type SettingsMap = {
  apiUrl?: string;
  language?: LanguageOption;
};
export type ALLOWED_SETTINGS_KEYS = keyof SettingsMap;
export type SettingValue = SettingsMap[ALLOWED_SETTINGS_KEYS];

export class Language {
  constructor(
    public value: LanguageOption,
    public label: string
  ) {}
}
const langNameDict = {
  de: "Deutsch",
  en: "English",
};
export const allLanguages: Language[] = Object.entries(langNameDict).map(
  ([value, label]) => new Language(value as LanguageOption, label)
);

export async function setSetting(key: ALLOWED_SETTINGS_KEYS, value: SettingValue): Promise<void> {
  const json = JSON.stringify(value);
  await OfficeRuntime.storage.setItem(key, json);
}

export async function getSetting(key: ALLOWED_SETTINGS_KEYS): Promise<SettingValue> {
  const json = await OfficeRuntime.storage.getItem(key);
  if (json === null || json === undefined) {
    return undefined;
  }
  try {
    return JSON.parse(json);
  } catch (e) {
    console.error("Error parsing setting", e);
    return undefined;
  }
}

export async function removeSetting(key: ALLOWED_SETTINGS_KEYS): Promise<void> {
  await OfficeRuntime.storage.removeItem(key);
}
